<div class="select-preferred-lang-wrapper">
  <p-select [options]="langs()" [(ngModel)]="selectedLang" optionLabel="name" placeholder="">
    <ng-template #selectedItem let-selectedOption>
      @if (selectedOption) {
        <div class="selected-lang">
          <img
            src="images/flags/{{ selectedOption.code | lowercase }}.png"
            [class]="'flag flag-' + (selectedOption.code | lowercase)"
            class="flag-img" />
        </div>
      }
    </ng-template>
    <ng-template let-lang #item>
      <div class="lang-option">
        <img
          src="images/flags/{{ lang.code | lowercase }}.png"
          [class]="'flag flag-' + (lang.code | lowercase)"
          class="flag-option-img" />
        <span>{{ lang.name }}</span>
      </div>
    </ng-template>
  </p-select>
</div>
